import { useLocation, useNavigate } from 'react-router-dom'
import { useVoucher } from '../hooks/useVoucher'
import ModalVoucherTags from '../components/ModalVoucherTags'
import VoucherIndex from '../components/VoucherIndex'
import ModalVoucherCancel from '../components/ModalVoucherCancel'
import { useEffect } from 'react'

export default function ListVoucher() {
  const location = useLocation()
  const navigate = useNavigate()
  const {
    toast,
    toastContainer,
    cancelVoucher,
    fetchVouchersStatus,
    vouchers,
    totalRowVouchers,
    pageVouchers,
    limitVouchers,
    keywordSearchVoucher,
    selectedTagsVoucher,
    isOpenModalVoucherTags,
    isOpenModalVoucherCancel,
    fetchVoucerList,
    fetchCancelVoucherStatus,
    handleChangeVoucherStatus,
    handleOpenModalVoucherCancel,
    setKeywordSearchVoucher,
    handleSearchVoucher,
    handleChangeCurrentLimit,
    handleChangeCurrentPage,
    handleSelectTag,
    handleSelectAdvancedFilter,
    setIsOpenModalVoucherTags,
    setIsOpenModalVoucherCancel,
  } = useVoucher()

  useEffect(() => {
    if (location.state && location.state.message) {
      toast(location.state.message, 'success')
    }
    navigate('/loyalty/vouchers', { replace: true })
  }, [])

  return (
    <div className="content-wrapper">
      {toastContainer}
      <VoucherIndex
        fetchStatus={fetchVouchersStatus}
        vouchers={vouchers}
        totalRow={totalRowVouchers}
        page={pageVouchers}
        limit={limitVouchers}
        keywordSearch={keywordSearchVoucher}
        selectedTag={selectedTagsVoucher}
        onChangePage={handleChangeCurrentPage}
        onChangeLimit={handleChangeCurrentLimit}
        onChangeKeywordSearch={setKeywordSearchVoucher}
        onEnterKeywordSearch={handleSearchVoucher}
        onSelectTag={handleSelectTag}
        onOpenModalTags={setIsOpenModalVoucherTags}
        onOpenModalCancel={handleOpenModalVoucherCancel}
        onChangeVoucherStatus={handleChangeVoucherStatus}
        onFetch={fetchVoucerList}
      />
      <ModalVoucherTags
        isOpen={isOpenModalVoucherTags}
        selectedTags={selectedTagsVoucher}
        onCancel={setIsOpenModalVoucherTags}
        onSave={handleSelectAdvancedFilter}
      />
      <ModalVoucherCancel
        isOpen={isOpenModalVoucherCancel}
        fetchStatus={fetchCancelVoucherStatus}
        onOpen={setIsOpenModalVoucherCancel}
        onSubmit={cancelVoucher}
      />
    </div>
  )
}
